import { StoreReviewEntity } from '@/services/types/store-review.type';
import Image from 'next/image';

interface Props extends StoreReviewEntity {
  className?: string;
}

const CommonReviewCard = (review: Props) => {
  return (
    <div
      key={review.id}
      className="desktop:px-5 desktop:py-8 desktop:rounded-xl h-full w-full rounded-lg border border-white/10 bg-[#292929] px-5 py-8"
    >
      {/* 상단: 사용자 ID (왼쪽) + 위치 정보 (오른쪽) */}
      <div className="mb-4 flex items-center justify-between">
        {/* 사용자 ID */}
        <h3 className="typo-20 desktop:typo-20 shrink-0 font-extrabold text-white">
          {review.username}
        </h3>

        {/* 위치 정보 */}
        <div className="ml-2 flex items-center gap-1">
          <Image
            src="/images/icons/icon_map_pin.svg"
            alt="지점 위치 아이콘"
            width={16}
            height={16}
            loading="eager"
          />
          <span className="typo-18 desktop:typo-18 line-clamp-1 font-semibold text-[#FF6B35]">
            {review.storeName}
          </span>
        </div>
      </div>

      {/* 리뷰 본문 */}
      <p className="typo-16 desktop:typo-16 desktop:leading-normal line-clamp-4 leading-snug font-semibold whitespace-pre-wrap text-[#D4D4D6]">
        {review.reviewText.replace(/\n/g, ' ')}
      </p>
    </div>
  );
};

export default CommonReviewCard;
